import { Route, Routes } from 'react-router-dom'
import { PageTitle } from '../../../../../_metronic/layout/core'
import { useT } from '_metronic/i18n/Metronici18n'
import { AuditoriaExport } from './AuditoriaExport'

const AuditoriaPage = () => {
  const { t } = useT()

  return (
    <Routes>
      <Route
        path=''
        element={
          <>
            <PageTitle description={t('auditoria_export.description')}>
              {t('auditoria_export.title')}
            </PageTitle>
            <AuditoriaExport />
          </>
        }
      />
    </Routes>
  )
}

export default AuditoriaPage
